import { render, staticRenderFns } from "./hotbusiness.vue?vue&type=template&id=fe7a09ea&scoped=true"
import script from "./hotbusiness.vue?vue&type=script&lang=js"
export * from "./hotbusiness.vue?vue&type=script&lang=js"
import style0 from "./hotbusiness.vue?vue&type=style&index=0&id=fe7a09ea&prod&scoped=true&lang=css"
import style1 from "./hotbusiness.vue?vue&type=style&index=1&id=fe7a09ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7a09ea",
  null
  
)

export default component.exports